import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { FishMapModule } from './fish-map/fish-map.module';
import { AppSettings, FishMapService, LoggerService, SettingsService } from './services';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    CoreModule.forRoot(),
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    FishMapModule,
    HttpClientModule
  ],
  providers: [
    AppSettings,
    FishMapService,
    LoggerService,
    SettingsService,    
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
